export default __webpack_public_path__ + "static/media/file.d3b72863.svg";